import { render, staticRenderFns } from "./SegmentsTab.vue?vue&type=template&id=e3447394&scoped=true"
import script from "./SegmentsTab.vue?vue&type=script&lang=ts"
export * from "./SegmentsTab.vue?vue&type=script&lang=ts"
import style0 from "./SegmentsTab.vue?vue&type=style&index=0&id=e3447394&prod&lang=scss&scoped=true"
import style1 from "./SegmentsTab.vue?vue&type=style&index=1&id=e3447394&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3447394",
  null
  
)

export default component.exports